export const FEATURE_FLAG_STATUS = {
  active: 'Activo',
  inactive: 'Desactivado',
  partial: 'Mixto',
  maintenance: 'En mantenimiento',
};
